import { Field, Form, Formik, useFormikContext } from "formik";
import Avatar from "react-avatar";
import { useSelector } from "react-redux";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import PhoneInputNumber from "../common/Form/MobileInput";
import ConfirmDialog from "../common/ConfirmDialog/ConfirmDialog";
import styles from "./userForm.module.scss"
import useModal from "../Hooks/useModal";
import FileInputField from "../common/Form/FileInput";
import { OnlyNumberAllow } from "../../helpers";
import { useEffect, useState } from "react";
import imageAvatar from "../../resources/images/img_avatar.png"
import cameraImg from "../../resources/images/camera.svg"
import removeImg from "../../resources/images/remove.svg"
import { BiEdit } from "react-icons/bi";
import { toast } from "react-toastify";
import passEye from "../../resources/images/pwdEye.svg";
import hideEye from "../../resources/images/hideEye.svg";
import { BsExclamation } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { authActions } from "../../actions/auth.actions";

const UserForm = (props) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.authentication.user);
    const { setFieldValue } = useFormikContext();
    let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
    const [selectedFile, setSelectedFile] = useState(null)
    const [preview, setPreview] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const { errors, touched } = props;
    const [eye, seteye] = useState(true);
    const [oldEye, setOldEye] = useState(true);
    const [password, setpassword] = useState("password");
    const [oldPassword, setOldpassword] = useState("password");

    const Eye = () => {
        if (password === "password") {
            setpassword("text");
            seteye(false);
        }
        else {
            setpassword("password");
            seteye(true);
        }
    };

    const oldPasswordEye = () => {
        if (oldPassword === "password") {
            setOldpassword("text");
            setOldEye(false);
        }
        else {
            setOldpassword("password");
            setOldEye(true);
        }
    };

    useEffect(() => {
        if (props?.editedData?.resource?.avtar?.url) {
            setHideDelete(false)
        } else {
            setHideDelete(true)
        }
    }, [props?.edited]);

    useEffect(() => {
        if (props?.editedData) {
            if (props.editedData?.resource?.phone) {
                setFieldValue("phone", props.editedData?.resource?.phone)
            }
        }
    }, [props.editedData])

    const handleBtnClick = () => {
        if (props?.edited) {
            const input = document.getElementById("avtar");
            if (input) {
                input.click();
            }
            if (props?.editedData?.resource?.avtar?.url) {
                setHideDelete(false);
            }
        }
    };

    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])
    function isFileSizeValid(file) {
        if (file) {
            return file?.size <= 1 * 1024 * 1000;
        } else {
            return true
        }
    }
    const handleFileEvent = (e) => {
        if (e.target.files.length && isFileSizeValid(e?.target?.files[0])) {
            setFieldValue('avtar', e.target.files[0]);
            setSelectedFile(e.target.files[0])
        } else if(e.target.files.length) {
            toast.error('File size cannot not be greater than 1 mb')
        }

        //handleUploadFiles(chosenFiles);
    };

    const handleRemoveAvatar = () => {
        dispatch(authActions.updateProfile({ removeAvtar: true })).then((res) => {
            setHideDelete(true);
            setPreview(undefined);
            setSelectedFile(undefined)
            props?.setEdited(false);
        })
    }

    const deleteAvtar = () => {
        ConfirmToggle();
    };
    return (
        <Form className={`${styles.userForm}`} encType="multipart/form-data">
            <Container className={styles.containerPart}>
                {props?.edited ?
                    "" : <div className={styles.editButton}>
                        <Button className={`btn btn-default ${styles.buttonPart}`} onClick={() => props?.setEdited(true)}>Edit <BiEdit /></Button>
                    </div>
                }
                <div className={styles.UserPart}>
                    <div className={styles.profilePic}>
                        {props?.editedData?.resource && props?.editedData?.resource?.avtar?.url && (!props.edited || selectedFile === null) ?
                            <img className={styles.profileImage} src={props?.editedData?.resource?.avtar?.url} />
                            :
                            selectedFile ? <img className={styles.profileImage} src={preview} />

                                :
                                <div className={styles.avtarPart}>
                                    <Avatar
                                        className={styles.commentAvt}
                                        name={user?.name.split(" ")[0] + user?.name.split(' ' [1])}
                                        size="130"
                                        round={true}
                                    />
                                </div>
                        }

                        {props.edited ?
                            <>
                                <Button className={styles.brandButton} onClick={() => handleBtnClick()}>
                                    Upload Picture
                                </Button>
                                {!hideDelete && < Button className={styles.removeBtn} onClick={() => deleteAvtar()}>
                                    Delete
                                </Button>}
                            </>
                            : ""
                        }
                        {errors.avtar && touched.avtar ? (
                            <div className={styles.formErrorUserInfo}>{errors.avtar}</div>
                        ) : null}
                    </div>

                </div>


                <input
                    type="file"
                    multiple
                    id="avtar"
                    name="avtar"
                    onChange={handleFileEvent}
                    style={{ display: "none" }}
                />
                <Row>
                    <Col md={6}>
                        <FormGroup className="form-group">
                            <Label className={styles.formLabel}>First Name</Label>
                            <Field
                                className="form-control"
                                name="name"
                                value={props.editedData?.resource?.name}
                                disabled={true}
                                autoComplete="off"
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="form-group">
                            <Label className={styles.formLabel}>Last Name</Label>
                            <Field
                                className="form-control"
                                name="lastname"
                                value={props.editedData?.resource?.lastName ? props.editedData?.resource?.lastName : ""}
                                disabled={true}
                                autoComplete="off"
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="form-group">
                            <Label className={styles.formLabel}>Email</Label>
                            <Field
                                className="form-control"
                                name="email"
                                value={props.editedData?.email}
                                disabled={true}
                                type="email"
                                autoComplete="off"
                            />

                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="form-group">
                            <Label className={styles.formLabel}>Phone</Label>
                            {/* <Field
                                className="form-control"
                                onKeyPress={(event) => {
                                    OnlyNumberAllow(event);
                                }}
                                name="phone"
                                id="phone"
                                type="text"
                                disabled={props?.edited ? false : true}
                            /> */}
                            <PhoneInputNumber name="phone" autoComplete="off" disabled={props?.edited ? false : true} />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        {props?.edited &&
                            <FormGroup className="form-group">
                                <Label className={styles.formLabel}>Old Password</Label>
                                <div className="input-text">
                                    <Field
                                        type={oldPassword}
                                        className="form-control"
                                        name="oldPassword"
                                        id="oldPassword"
                                        autoComplete="off"
                                        maxlength="15"
                                        disabled={props?.edited ? false : true}
                                    />
                                    {props?.edited ? <img onClick={oldPasswordEye} className="eye-icons" src={oldEye ? hideEye : passEye} alt="" /> : null}
                                </div>
                                {errors.oldPassword && touched.oldPassword ? (
                                    <div className={styles.formError}>{errors.oldPassword}</div>
                                ) : null}
                            </FormGroup>
                        }
                    </Col>
                    <Col md={6}>
                        {props?.edited &&
                            <FormGroup className="form-group">
                                <Label className={styles.formLabel}>New Password</Label>
                                <div className="input-text">
                                    <Field
                                        type={password}
                                        className="form-control"
                                        name="newPassword"
                                        id="newPassword"
                                        autoComplete="off"
                                        maxlength="15"
                                        disabled={props?.edited ? false : true}
                                    />
                                    {props?.edited ? <img onClick={Eye} className="eye-icons" src={eye ? hideEye : passEye} alt="" /> : null}
                                </div>
                                {errors.password && touched.password ? (
                                    <div className={styles.formError}>{errors.password}</div>
                                ) : null}
                            </FormGroup>
                        }
                    </Col>
                    <Col md={6}>
                        {props?.edited &&
                            <FormGroup className="form-group">
                                <Label className={styles.formLabel}>Confirm Password</Label>
                                <div className="input-text">
                                    <Field
                                        type={password}
                                        className="form-control"
                                        name="cPassword"
                                        id="cPassword"
                                        autoComplete="off"
                                        maxlength="15"
                                        disabled={props?.edited ? false : true}
                                    />
                                    {props?.edited ? <img onClick={Eye} className="eye-icons" src={eye ? hideEye : passEye} alt="" /> : null}
                                </div>
                                {errors.cPassword && touched.cPassword ? (
                                    <div className={styles.formError}>{errors.cPassword}</div>
                                ) : null}
                            </FormGroup>
                        }
                    </Col>
                </Row>
                {props?.edited ?
                    <>
                        <Button type="submit" className={styles.brandButton} disabled={props?.edited ? false : true}>
                            Update Info
                        </Button>
                        <Button type="reset"
                            className={`${styles.brandButton} mx-2`}
                            disabled={props?.edited ? false : true}
                            onClick={() => {
                                setFieldValue("phone", props.editedData?.resource?.phone ? props.editedData?.resource?.phone : "")
                                setFieldValue("oldPassword", "")
                                setFieldValue("newPassword", "")
                                setFieldValue("cPassword", "")
                                setFieldValue("avatar", "")
                                props?.setEdited(false)
                            }}>
                            Cancel
                        </Button>
                    </>
                    : ""
                }

            </Container>

            <ConfirmDialog
                visible={ConfirmModal}
                toggle={ConfirmToggle}
                type='info'
                removeAvtar='removeAvtar'
                title="Are you sure you want to delete the profile Picture?"
                handleRemoveAvatar={() => handleRemoveAvatar()}
            >

                <div className={`confirmIcon rounded-circle`}>
                    <BsExclamation style={{ fontSize: 42 }} />
                </div>
            </ConfirmDialog>

        </Form >
    )

}
export default UserForm;